<template>
  <div>
    <!-- Header -->
    <div class="header bg-gradient-success py-7 py-lg-8 pt-lg-9">
      <div class="container">
        <div class="header-body text-center mb-7">
          <div class="row justify-content-center">
            <div class="col-xl-5 col-lg-6 col-md-8 px-5">
              <h1 class="text-white">
                Customized Translation <br />Service for Professionals
              </h1>
              <p class="text-lead text-white">
                You can dramatically reduce the translation time
                <br />by using the fast and accurate AI translator <br />through
                the services.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="separator separator-bottom separator-skew zindex-100">
        <svg
          x="0"
          y="0"
          viewBox="0 0 2560 100"
          preserveAspectRatio="none"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <polygon
            class="fill-default"
            points="2560 0 2560 100 0 100"
          ></polygon>
        </svg>
      </div>
    </div>
    <!-- Page content -->
    <div class="container mt--8 pb-5">
      <div class="row justify-content-center">
        <div class="col-lg-5 col-md-7">
          <div class="card bg-secondary border-0 mb-0">
            <div class="card-body px-lg-5 py-lg-5">
              <div class="text-center text-muted mb-4">
                <small>2 Factor Verification</small>
              </div>
              <validation-observer
                v-slot="{ handleSubmit }"
                ref="formValidator"
              >
                <form role="form" @submit.prevent="handleSubmit(onSubmit)">
                  <div v-if="result">
                    <p class="text-center text-lead">
                      {{ result }}
                    </p>
                  </div>
                  <template>
                    <base-input
                      alternative
                      class="mb-3"
                      prepend-icon="fas fa-id-badge"
                      placeholder="Enter the code you received by email"
                      name="Code"
                      rules="required"
                      v-model="code"
                    >
                    </base-input>
                  </template>
                  <div class="text-center">
                    <base-button
                      type="default"
                      class="my-4"
                      @click="resend"
                    >
                      Resend Email
                    </base-button>
                    <base-button
                      type="primary"
                      native-type="submit"
                      class="my-4"
                    >
                      Verify Code
                    </base-button>
                  </div>
                  <div
                    class="invalid-feedback text-center"
                    style="display: block;"
                  >
                    {{ message }}
                  </div>
                </form>
              </validation-observer>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-6">
              <router-link to="/login" class="text-light" replace>
                <small>Back to login page</small>
              </router-link>
            </div>
            <div class="col-6 text-right">
              <router-link to="/register" class="text-light">
                <small>Register</small>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'

export default {
  data() {
    return {
      code: '',
      result: '',
      message: '',
    }
  },
  computed: {
    ...mapState(['loginPayload']),
  },
  methods: {
    async onSubmit() {
      console.log('onSubmit', arguments, this.code, this.loginPayload)
      const result = await this.$store.dispatch('login',
        Object.assign({}, this.loginPayload, { two_factor_code: this.code })
      )
      console.log('after verify', result)
      if (result) {
        this.result = 'Code Verified'
        await this.$router.push('/')
      } else {
        this.result = 'The verification code is valid for 30 minutes.'
        this.message = 'Invalid Code'
      }
    },
    async resend() {
      this.result = 'Check your email for a verification code.'
      this.message = ''
      this.loginPayload.two_factor_code = null
      await this.$store.dispatch('login', this.loginPayload)
    },
  },
}
</script>
